'use strict';

frontendApp.factory('CursorService', ['$rootScope', '$q', 'ConfigService', 'ResourceService', function ($rootScope, $q, ConfigService, ResourceService) {

  var proxy = null;
  var fetching = false;

  var pagination = {
    currentPage: null,
    totalPages: null,
    totalResources: null,
    resourcesPerPage: null,
    resources: []
  };

  var viewing = {
    index: -1
  };

  var isFirstOnPage = function () {
    return (viewing.index == 0);
  };
  var isLastOnPage = function () {
    return (viewing.index == (pagination.resources.length - 1));
  };

  var launchFullViewAtIndex = function (index) {
    viewing.index = index;
    var resource = pagination.resources[viewing.index];

    // Search Results or normal results
    if (_.has(resource, 'fields')) {
      ResourceService.LaunchFullView({
        projectId: resource.fields.projectId,
        collectionId: resource.fields.collectionId,
        resourceId: resource._id
      });
    } else {
      ResourceService.LaunchFullView({
        projectId: resource.projectId,
        collectionId: resource.collectionId,
        resourceId: resource.id
      });
    }

    fetching = false;
  };

  var _service = {};

  // Object must implement the methods below
  _service.setProxy = function (obj) {
    proxy = obj;
  };

  _service.refresh = function (callback) {
    proxy.refresh(callback);
  };

  _service.next = function () {

    if (!_service.hasNext()) {
      return;
    }

    if (fetching) {
      console.log('Blocking NEXT, fetch in progress');
      return;
    }
    fetching = true;

    if (isLastOnPage()) {
      // Get the next page, then get the first item
      var promise = proxy.nextPage();
      promise.then(function () {
        launchFullViewAtIndex(0);
      });

    } else {
      launchFullViewAtIndex(viewing.index + 1);
    }
  };

  _service.previous = function () {

    if (!_service.hasPrevious()) {
      return;
    }

    if (fetching) {
      console.log('Blocking NEXT, fetch in progress');
      return;
    }
    fetching = true;

    if (isFirstOnPage()) {

      var promise = proxy.previousPage();
      promise.then(function () {
        launchFullViewAtIndex(pagination.resources.length - 1);
      });

    } else {
      launchFullViewAtIndex(viewing.index - 1);
    }
  };

  _service.getCurrentPage = function () {
    return pagination.currentPage;
  };

  _service.getTotalPages = function () {
    return pagination.totalPages;
  };

  _service.hasPrevious = function () {
    return (pagination.currentPage > 1 || (pagination.currentPage == 1 && !isFirstOnPage()));
  };

  _service.hasNext = function () {
    return (pagination.currentPage < pagination.totalPages || (pagination.currentPage == pagination.totalPages && !isLastOnPage()));
  };

  _service.getResources = function () {
    return pagination.resources;
  };

  _service.getPagination = function () {
    return pagination;
  };

  _service.getResourceNumber = function () {
    return (((pagination.currentPage - 1) * pagination.resourcesPerPage) + (viewing.index + 1));
  };

  _service.getTotalResources = function () {
    return pagination.totalResources;
  };

  _service.getCurrentIndex = function () {
    return viewing.index;
  };

  _service.getActiveQuery = function () {
    if (proxy.activeQuery) {
      return proxy.activeQuery();
    }
  };

  /**
   * Set when a new page of results comes back from the server
   *
   * @param currentPage
   * @param totalPages
   * @param totalResources
   * @param resources
   */
  _service.setPagination = function (currentPage, totalPages, totalResources, resourcesPerPage, resources) {
    viewing.index = -1;
    pagination.currentPage = currentPage;
    pagination.totalPages = totalPages;
    pagination.totalResources = totalResources;
    pagination.resourcesPerPage = resourcesPerPage;
    pagination.resources = resources;
    // console.log('SetPagination: ', pagination);
  };

  /**
   * Set when we look launch fullview on a record
   *
   * @param index
   */
  _service.setViewing = function (index) {
    viewing.index = index;
    // console.log('SetViewing: ', viewing);
  };

  return _service;

}]);
